<template>
  <v-container id="restaurantes" tag="section">
    <base-v-component heading="Restaurantes del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          v-if="isAdmin"
          color="success"
          dark
          class="mb-2"
          @click.stop="showDialog()"
          >{{ formTitle }}</v-btn
        >
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <!--DIALOGO EDITAR-->
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col xs12 sm6>
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      :error-messages="nombreErrors"
                      @input="$v.nombre.$touch()"
                      @blur="$v.nombre.$touch()"
                      ref="nombreReferencia"
                    ></v-text-field>
                  </v-col>
                  <v-col xs12 sm6>
                    <v-text-field
                      v-model="telefono"
                      label="Telefono"
                    ></v-text-field>
                  </v-col>
                  <v-col xs12 sm6>
                    <v-text-field
                      v-model="codigoRest"
                      label="codigoRest"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      v-model="email"
                      label="Email"
                      :error-messages="emailErrors"
                      @input="$v.email.$touch()"
                      @blur="$v.email.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="cif" label="CIF"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      v-model="latitud"
                      label="latitud"
                      :error-messages="latitudErrors"
                      @input="$v.latitud.$touch()"
                      @blur="$v.latitud.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="longitud"
                      label="longitud"
                      :error-messages="longitudErrors"
                      @input="$v.longitud.$touch()"
                      @blur="$v.longitud.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="codigoProvincia"
                      label="Codigo Provincia"
                      :items="provincias"
                      :search-input.sync="searchSelect"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="direccion"
                      label="Dirección Fiscal"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      label="Impuesto por defecto"
                      :items="impuestosSelect"
                      v-model="impuesto"
                      messages="Se puede cambiar por producto del restaurante"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-checkbox v-model="mapeoNeo" label="Neo" />
                  </v-col>
                  <v-col
                    cols="4"
                    v-if="!!negocio.mapeoNeoRestaurante && mapeoNeo"
                  >
                    <!--si es centralizado damos la opción de que se haga individual-->
                    <v-checkbox
                      v-model="mapeoNeoRestauranteForzado"
                      label="Neo independiente"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox v-model="vromo" label="Vromo" />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="printNode"
                      @change="openImpresoras"
                      label="PrintNode"
                    />
                  </v-col>
                </v-row>
                <!--<template v-if="mapeoNeo">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="datosNeo.url"
                        :append-icon="showUrl ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showUrl ? 'text' : 'password'"
                        @click:append="showUrl = !showUrl"
                        label="Url"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="datosNeo.centro"
                        :append-icon="showCentro ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showCentro ? 'text' : 'password'"
                        @click:append="showCentro = !showCentro"
                        label="centro"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="datosNeo.apikey"
                        :append-icon="showApikey ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showApikey ? 'text' : 'password'"
                        @click:append="showApikey = !showApikey"
                        label="Api Key"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>-->
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--DIALOGO FACTURACION-->
        <v-dialog v-model="dialogConfigFacturacion.dialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline"
                >FACTURACIÓN {{ cabeceraDialogoFacturacion }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row justify="center">
                  <v-col cols="12" sm="4">
                    <v-text-field
                      :disabled="mostrarTodosDatos"
                      :loading="dialogConfigFacturacion.loading"
                      v-model="datosFacturacion.cuentaAsociada"
                      label="Id cuenta asociada Stripe"
                      append-icon="mdi-link"
                      prepend-icon="mdi-delete"
                      @click:append="abrirEnlaceStripe"
                      @click:prepend="borrarCuentaStripe"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-select
                      :loading="dialogConfigFacturacion.loading"
                      :items="selectCopiarRestFacturacion"
                      v-model="datosFacturacion.copiarRest"
                      label="¿Se factura con otro restaurante?"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-select
                      :disabled="mostrarTodosDatos"
                      :loading="dialogConfigFacturacion.loading"
                      label="Impuesto facturación concepto online"
                      :items="$store.getters['impuestos/getImpuestosSelect']"
                      v-model="datosFacturacion.impuesto"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-card
                    width="50%"
                    class="mx-auto"
                    :disabled="mostrarTodosDatos"
                  >
                    <v-list-item>
                      <v-list-item-avatar color="primary">
                        <v-icon class="white--text">mdi-currency-eur</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline"
                          >TASAS PAGO ONLINE</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >Se aplica a cada pago online y se retiene a la hora
                          de pasarlo a su cuenta asociada</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Porcentaje por pedido pago online"
                            v-model="
                              datosFacturacion.tasaPorcentajePedidoPagoOnline
                            "
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Valor fijo por pedido pago online"
                            v-model="datosFacturacion.tasaFijaPedidoPagoOnline"
                          />
                        </v-col>
                      </v-row>
                      <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                    </v-card-text>
                  </v-card>
                  <v-card
                    width="50%"
                    class="mx-auto"
                    :disabled="mostrarTodosDatos"
                  >
                    <v-list-item>
                      <v-list-item-avatar color="primary">
                        <v-icon class="white--text">mdi-currency-eur</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline"
                          >TASAS PEDIDO</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >Se aplica a cada pedido y se facturará al terminar el
                          periodo</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Porcentaje por pedido"
                            v-model="datosFacturacion.tasaPorcentajePedido"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Valor fijo por pedido pago online"
                            v-model="datosFacturacion.tasaFijaPedido"
                          />
                        </v-col>
                      </v-row>
                      <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                    </v-card-text>
                  </v-card>
                </v-row>
                <v-divider />
                <v-row>
                  <v-card width="100%" :disabled="mostrarTodosDatos">
                    <v-card-title>Datos Facturación</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            label="CIF"
                            v-model="datosFacturacion.cif"
                          />
                        </v-col>
                        <v-col cols="12" sm="8">
                          <v-text-field
                            label="Nombre"
                            v-model="datosFacturacion.nombre"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-model="datosFacturacion.direccion"
                            label="Dirección"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="datosFacturacion.cp"
                            label="Código postal"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="datosFacturacion.municipio"
                            label="Municipio"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="datosFacturacion.provincia"
                            label="Provincia"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="emailsFacturacionComputados"
                            label="Emails de envio (separados por comas)"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeDialogoConfigFacturacion"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveDialogoConfigFacturacion"
                :loading="dialogConfigFacturacion.loading"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="restaurantes"
        :loading="loading"
        :search="search"
        :mobile-breakpoint="0"
      >
        <template v-slot:item.estado="{ item }">
          <v-chip
            v-if="loadingComprobar"
            class="ma-2"
            color="info"
            text-color="white"
            >Comprobando</v-chip
          >
          <v-chip
            v-if="item.estado == 'conectado' && !loadingComprobar"
            class="ma-2"
            color="green"
            text-color="white"
            @click="comprobarConexion(item)"
            >Online</v-chip
          >
          <v-chip
            v-else-if="!loadingComprobar"
            @click="comprobarConexion(item)"
            class="ma-2"
            color="red"
            text-color="white"
            >Offline</v-chip
          >
          <v-chip
            v-if="item.horariosApertura[0]"
            class="ma-2"
            color="green"
            text-color="white"
            >Domicilio</v-chip
          >
          <v-chip v-else class="ma-2" color="red" text-color="white"
            >Domicilio</v-chip
          >
          <v-chip
            v-if="item.horariosApertura[1]"
            class="ma-2"
            color="green"
            text-color="white"
            >Recoger</v-chip
          >
          <v-chip v-else class="ma-2" color="red" text-color="white"
            >Recoger</v-chip
          >
          <v-chip
            v-if="item.horariosApertura[2]"
            class="ma-2"
            color="green"
            text-color="white"
            >Apertura</v-chip
          >
          <v-chip v-else class="ma-2" color="red" text-color="white"
            >Apertura</v-chip
          >
        </template>
        <template v-slot:item.acciones="{ item }" v-if="isAdmin">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top v-if="!item.inactivo">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  :loading="loadingActivo"
                  small
                  v-on="on"
                  @click="changeActivo(item)"
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  :loading="loadingActivo"
                  color="red"
                  min-width="0"
                  small
                  v-on="on"
                  @click="changeActivo(item)"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="grey"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goConfiguracion(item)"
                >
                  <v-icon small>mdi-pill</v-icon>
                </v-btn>
              </template>
              <span>Configuración</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="pink"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goCarta(item)"
                >
                  <v-icon small>mdi-newspaper</v-icon>
                </v-btn>
              </template>
              <span>Carta restaurante</span>
            </v-tooltip>
            <v-tooltip top v-if="mostrarBotonFacturacion">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="purple"
                  min-width="0"
                  small
                  v-on="on"
                  @click="showDialogConfigFacturacion(item)"
                >
                  <v-icon small>mdi-currency-eur</v-icon>
                </v-btn>
              </template>
              <span>Facturación del restaurante</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goZona(item)"
                >
                  <v-icon small>mdi-map</v-icon>
                </v-btn>
              </template>
              <span>Zonas de reparto</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="blue"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goHorarios(item)"
                >
                  <v-icon small>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <span>Horarios</span>
            </v-tooltip>
            <v-tooltip top v-if="!!item.mapeoNeoRestauranteForzado">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 black--text"
                  color="yellow"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goProductosRest(item)"
                >
                  <v-icon small>mdi-shopping</v-icon>
                </v-btn>
              </template>
              <span>Productos asociados</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 white--text"
                  color="primary"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goProductosCatalogoRest(item)"
                >
                  <v-icon small>mdi-shopping</v-icon>
                </v-btn>
              </template>
              <span>Catálogo de productos</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 white--text"
                  color="blue"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goTarifasCatalogoRest(item)"
                >
                  <v-icon small>mdi-shopping</v-icon>
                </v-btn>
              </template>
              <span>Tarifas por catálogo de productos</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 white--text"
                  color="purple"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goTpv(item)"
                >
                  <v-icon small>mdi-laptop</v-icon>
                </v-btn>
              </template>
              <span>TPVs</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 white--text"
                  color="orange"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goReservas(item)"
                >
                  <v-icon small>mdi-calendar-clock</v-icon>
                </v-btn>
              </template>
              <span>Reservas</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="isAdmin"
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  small
                  @click="editItemDialog(item)"
                  v-on="on"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="red"
                  min-width="0"
                  small
                  @click="deleteItem(item)"
                  v-if="isAdmin"
                  v-on="on"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>


<script>
import { createSlug } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { restSinNegocio } from "@/utils/restaurantes.utils.js";
export default {
  mixins: [validationMixin],
  validations: {
    nombre: { required, minLength: minLength(4) },
    latitud: { required, minLength: minLength(2) },
    longitud: { required, minLength: minLength(2) },
    email: { required, email },
  },
  data() {
    return {
      loadingComprobar: false,
      loading: false,
      loadingForm: false,
      loadingActivo: false,
      dialog: false,
      search: "",
      searchSelect: "",
      id: null,
      nombre: "",
      telefono: "",
      codigoRest: "",
      email: "",
      direccion: "",
      latitud: "",
      longitud: "",
      codigoProvincia: "",
      impuesto: null,
      cif: "",
      mapeoNeo: false,
      mapeoNeoRestauranteForzado: false,
      datosNeo: {
        url: null,
        centro: null,
        apikey: null,
      },
      showApikey: false,
      showCentro: false,
      showUrl: false,
      vromo: false,
      printNode: false,
      isLoadingSelect: false,
      searchImpresora: "",
      impresorasRest: [],
      dialogConfigFacturacion: {
        dialog: false,
        restaurante: null,
        loading: false,
      },
      datosFacturacion: {
        cuentaAsociada: "",
        tasaPorcentajePedidoPagoOnline: 0,
        tasaFijaPedidoPagoOnline: 0,
        tasaPorcentajePedido: 0,
        tasaFijaPedido: 0,
        tasaFijaServicio: 0,
        nombre: "",
        cif: "",
        direccion: "",
        cp: "",
        municipio: "",
        provincia: "",
        emails: [],
        copiarRest: null,
      },
      headers: [
        {
          sortable: false,
          text: "Estado",
          value: "estado",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        // {
        //   sortable: false,
        //   text: "Teléfono",
        //   value: "telefono",
        // },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    mostrarTodosDatos() {
      return (
        this.datosFacturacion.copiarRest &&
        this.datosFacturacion.copiarRest != "matriz"
      );
    },
    selectCopiarRestFacturacion() {
      let v = this.dialogConfigFacturacion.restaurante
        ? this.$store.getters["restaurantes/getRestaurantesSelect"].filter(
            (r) => r.value != this.dialogConfigFacturacion.restaurante.id
          )
        : [];

      v.unshift({ value: "matriz", text: "-- ES EL MATRIZ --" });
      v.unshift({ value: null, text: "-- NO --" });

      return v;
    },
    emailsFacturacionComputados: {
      get() {
        return this.datosFacturacion.emails
          ? this.datosFacturacion.emails.toString().trim()
          : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.datosFacturacion.emails = val.split(expresionRegular);
      },
    },
    formTitle() {
      return this.isEdit ? "Editar Restaurante" : "Nuevo Restaurante";
    },
    cabeceraDialogoFacturacion() {
      return this.dialogConfigFacturacion.restaurante
        ? this.dialogConfigFacturacion.restaurante.negocio
            .replace(/-/g, " ")
            .toUpperCase() +
            " " +
            this.dialogConfigFacturacion.restaurante.id
              .replace(/-/g, " ")
              .toUpperCase()
        : "";
    },
    mostrarBotonFacturacion() {
      return (
        this.datosFacturacionNegocio &&
        this.datosFacturacionNegocio.modoFacturacion == "restauranteIndividual"
      );
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      provincias: (state) => state.negocios.provinciasSelect,
      datosFacturacionNegocio: (state) =>
        state.facturacion.datosFacturacionNegocioGest,
    }),
    ...mapGetters({
      role: "auth/role",
      isAdmin: "auth/isAdmin",
      negocio: "app/negocioGestObj",
      restaurantes: "restaurantes/getRestaurantesListado",
      impuestosSelect: "impuestos/getImpuestosSelect",
      impresoras: "negocios/getSelectImpresoras",
    }),
    subtitle() {
      return "Listado de restaurantes de " + this.negocio.nombre;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail es obligatorio");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio");
      return errors;
    },
    latitudErrors() {
      const errors = [];
      if (!this.$v.latitud.$dirty) return errors;
      !this.$v.latitud.required && errors.push("obligatorio");
      !this.$v.latitud.minLength && errors.push("Muy corto");
      return errors;
    },
    longitudErrors() {
      const errors = [];
      if (!this.$v.longitud.$dirty) return errors;
      !this.$v.longitud.required && errors.push("obligatorio");
      !this.$v.longitud.minLength && errors.push("Muy corto");
      return errors;
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "dialogConfigFacturacion.dialog"(val) {
      val || this.closeDialogoConfigFacturacion();
    },
    "datosFacturacion.copiarRest"(val) {
      if (val && val != "matriz") {
        let _vm = this;
        this.$store
          .dispatch("restaurantes/getFacturacion", val)
          .then((r) => {
            if (r) {
              delete r.copiarRest;
              for (const key of Object.keys(r)) {
                //if (key in _vm.datosFacturacion) {
                // or obj1.hasOwnProperty(key)
                _vm.datosFacturacion[key] = r[key];
                //}
              }
            }
          })
          .finally(() => (_vm.dialogConfigFacturacion.loading = false));
      }
    },
  },
  methods: {
    borrarCuentaStripe() {
      this.loadingStripe = true;
      let _vm = this;
      let r = confirm("¿Quieres eliminar la cuenta? (no se puede deshacer)");
      if (r) {
        return this.$store
          .dispatch(
            "negocios/borrarCuentaStripe",
            this.dialogConfigFacturacion.restaurante.id
          )
          .then((r) => {
            if (r.data && r.data.ok) {
              // window.open(r.data.url, "_blank");
              alert("ok, o yo que se ya");
            }
          })
          .finally(() => {
            _vm.loadingStripe = false;
          });
      }
    },
    abrirEnlaceStripe() {
      this.loading = true;
      let _vm = this;

      return this.$store
        .dispatch(
          "restaurantes/enlaceStripe",
          this.dialogConfigFacturacion.restaurante.id
        )
        .then((r) => {
          if (r.data && r.data.ok) {
            window.open(r.data.url, "_blank");
          }
        })
        .finally(() => {
          _vm.loading = false;
        });
    },
    comprobarConexion(item) {
      let _vm = this;
      _vm.loadingComprobar = true;
      this.$store
        .dispatch("restaurantes/comprobarConexion", item)
        .finally(() => (_vm.loadingComprobar = false));
    },
    changeActivo(item) {
      let _vm = this;
      _vm.loadingActivo = true;
      this.$store
        .dispatch("restaurantes/changeActivo", item)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Restaurante cambiado",
          });
          _vm.getRestaurantes();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar el restaurante",
          });
        })
        .finally(() => {
          _vm.loadingActivo = false;
        });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.nombre = "";
      this.email = "";
      this.telefono = "";
      this.codigoRest = "";
      this.id = null;
      this.cif = "";
      this.direccion = "";
      this.latitud = "";
      this.longitud = "";
      this.mapeoNeo = false;
      this.mapeoNeoRestauranteForzado = false;
      this.vromo = false;
      this.showApikey = false;
      this.showCentro = false;
      this.showUrl = false;
      this.datosNeo = {
        url: null,
        centro: null,
        apikey: null,
      };
    },
    reload() {
      this.getRestaurantes();
    },
    editItemDialog(item) {
      this.nombre = item.nombre;
      this.email = item.email;
      this.telefono = item.telefono;
      this.codigoRest = item.codigoRest;
      this.id = item.id;
      (this.direccion = item.direccion), (this.cif = item.cif);
      this.latitud = item.latitud;
      this.longitud = item.longitud;
      this.printNode = item.printNode;
      this.vromo = item.vromo ? item.vromo : false;
      //this.impresorasRest = (item.impresorasPrintNode) ? item.impresorasPrintNode : [];
      this.mapeoNeo = item.mapeoNeo ? item.mapeoNeo : false;
      this.mapeoNeoRestauranteForzado = item.mapeoNeoRestauranteForzado
        ? item.mapeoNeoRestauranteForzado
        : false;

      this.codigoProvincia = ("0" + item.codigoProvincia).slice(-2);
      this.impuesto = item.impuesto;
      this.datosNeo = item.datosNeo
        ? item.datosNeo
        : { url: null, centro: null, apikey: null };
      this.dialog = true;
      if (item.printNode) {
        this.openImpresoras();
      }
    },
    addRestaurante() {
      let rest = {
        email: this.email,
        nombre: this.nombre,
        cif: this.cif,
        telefono: this.telefono,
        codigoRest: this.codigoRest,
        direccion: this.direccion,
        negocio: this.negocio.id,
        latitud: this.latitud,
        longitud: this.longitud,
        //datosNeo: this.datosNeo ? this.datosNeo : null,
        mapeoNeo: this.mapeoNeo ? this.mapeoNeo : false,
        mapeoNeoRestauranteForzado: this.mapeoNeoRestauranteForzado
          ? this.mapeoNeoRestauranteForzado
          : false,
        printNode: this.printNode ? this.printNode : false,
        vromo: this.vromo ? this.vromo : false,
        //impresorasPrintNode : (this.impresorasRest) ? this.impresorasRest : [],
        codigoProvincia: parseInt(this.codigoProvincia),
        impuesto: this.impuesto ? this.impuesto : null,
        id: this.id,
      };
      return this.$store.dispatch("restaurantes/addRestaurante", rest);
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addRestaurante()
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Restaurante grabado con éxito",
              });
              _vm.getRestaurantes();
              _vm.dialog = false;
            })
            .catch((error) => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar el restaurante",
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
    deleteItem(item) {
      let r = confirm(
        "¿Quieres eliminar el restaurante? (no se puede deshacer)"
      );
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("restaurantes/deleteRestaurante", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Restaurante eliminada",
            });
            _vm.getRestaurantes();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getRestaurantes() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("restaurantes/getRestaurantes")
        .finally(() => {
          _vm.loading = false;
        });
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    showDialogConfigFacturacion(item) {
      this.dialogConfigFacturacion.dialog = true;
      this.dialogConfigFacturacion.restaurante = item;
      this.dialogConfigFacturacion.loading = true;
      let _vm = this;
      this.$store
        .dispatch("restaurantes/getFacturacion", item.id)
        .then((r) => {
          if (r) _vm.datosFacturacion = r;
        })
        .finally(() => (_vm.dialogConfigFacturacion.loading = false));
    },
    closeDialogoConfigFacturacion() {
      this.dialogConfigFacturacion.dialog = false;
      this.dialogConfigFacturacion.restaurante = null;
      this.datosFacturacion = {
        cuentaAsociada: "",
        tasaPorcentajePedidoPagoOnline: 0,
        tasaFijaPedidoPagoOnline: 0,
        tasaPorcentajePedido: 0,
        tasaFijaPedido: 0,
        tasaFijaServicio: 0,
      };
    },
    saveDialogoConfigFacturacion() {
      let _vm = this;

      this.dialogConfigFacturacion.loading = true;
      this.datosFacturacion.tasaPorcentajePedidoPagoOnline = parseFloat(
        this.datosFacturacion.tasaPorcentajePedidoPagoOnline
      );
      this.datosFacturacion.tasaFijaPedidoPagoOnline = parseFloat(
        this.datosFacturacion.tasaFijaPedidoPagoOnline
      );
      this.datosFacturacion.tasaFijaPedido = parseFloat(
        this.datosFacturacion.tasaFijaPedido
      );
      this.datosFacturacion.tasaPorcentajePedido = parseFloat(
        this.datosFacturacion.tasaPorcentajePedido
      );
      this.datosFacturacion.tasaFijaServicio = parseFloat(
        this.datosFacturacion.tasaFijaServicio
      );

      this.$store
        .dispatch("restaurantes/saveFacturacion", {
          facturacion: this.datosFacturacion,
          rest: this.dialogConfigFacturacion.restaurante.id,
        })
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos de facturación grabados con éxito",
          });
          _vm.closeDialogoConfigFacturacion();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los datos de facturación",
          });
        })
        .finally(() => {
          _vm.dialogConfigFacturacion.loading = false;
        });
    },
    goConfiguracion(item) {
      let str;
      switch (this.role) {
        case "admin":
          str = "/admin/gest/" + this.negocio.id;
          break;
        case "boss_negocio":
          str = "/admin/negocio";
          break;
      }
      str = str + "/restaurantes/" + restSinNegocio(item) + "/configuracion";
      this.$router.push(str);
    },
    goCarta(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/carta";
      this.$router.push(str);
    },
    goZona(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/zonasreparto";
      this.$router.push(str);
    },
    goHorarios(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/horarios";
      this.$router.push(str);
    },
    goProductosRest(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/productos";
      this.$router.push(str);
    },
    goProductosCatalogoRest(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/productoscatalogo";
      this.$router.push(str);
    },
    goTarifasCatalogoRest(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/tarifascatalogo";
      this.$router.push(str);
    },
    goTpv(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/tpv";
      this.$router.push(str);
    },
    goReservas(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(item) +
        "/reservas";
      this.$router.push(str);
    },
    openImpresoras(val) {
      if (val) {
        let _vm = this;
        this.isLoadingSelect = true;
        this.$store
          .dispatch("negocios/getImpresorasNegocio")
          .then(() => {})
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error: " + e,
            });
          })
          .finally(() => (_vm.isLoadingSelect = false));
      }
    },
  },
  mounted() {},
};
</script>

<style>
.border {
  border: 1px solid #000;
}
</style>